module.exports = __webpack_public_path__ + "static/img/header3.a6233d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/header3.jpg
// module id = NXPr
// module chunks = 1